import { genComponentEl } from '@/utils/utils';
import Component from './index.vue';

/**
 * 模拟设备报警
 * @param {Object} data
 */
export function setDeviceAnalogAarm(data) {
  genComponentEl(Component, data);
}
